import { Container } from '@/atoms';
import { TwoColumn } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeInfoSellerProps } from './types';

/**
 * InfoSeller
 */
export const InfoSeller: FunctionComponent<TypeInfoSellerProps> = ({
  className = '',
  title,
  description,
  backgroundColor,
  children,
}: TypeInfoSellerProps) => (
  <Container
    wrapper
    padding="py-6 md:py-8 px-4"
    style={{
      backgroundColor,
    }}
  >
    <TwoColumn className={`gap-6 ${className}`}>
      <TwoColumn.Left>
        <div className="flex flex-col gap-6">
          <h2 className="u-headline u-headline--h2">{title}</h2>
          {description && (
            <div
              className="u-body u-body--s max-w-[472px] md:u-body--m"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      </TwoColumn.Left>

      <TwoColumn.Rigth className="flex items-center justify-end">
        {children}
      </TwoColumn.Rigth>
    </TwoColumn>
  </Container>
);

InfoSeller.displayName = 'InfoSeller';
